"use client";

import { ArrowUpRight, Car, ShieldCheck, Clock, MapPin, Users, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const labs = [{
  id: "SVC-01",
  name: "Executive Fleet",
  description: "A curated selection of premium vehicles maintained to the highest standards of comfort and performance.",
  tags: ["#LUXURY", "#SEDAN", "#SUV"],
  accentVar: "--chart-1",
  image: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3111-1.webp?v=1p4bt6prv1x",
  srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3111-1.webp?v=usowlkum7a-wvc-srcset",
  sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3111-1.webp?v=q3fpxk19yj-wvc-sizes",
  icon: Car,
  link: {
    href: "https://book.mylimobiz.com/v4/bemax",
    newTab: true
  }
}, {
  id: "[SV-02]",
  name: "Professional Chauffeurs",
  description: "Discreet, highly trained professionals dedicated to your safety, privacy, and seamless travel experience.",
  tags: ["#PROFESSIONAL", "#DISCREET", "#CERTIFIED"],
  accentVar: "--chart-3",
  image: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3092-2.png?v=cwvecucetib",
  srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3092-2.png?v=tdo4ua7gskf-wvc-srcset",
  sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3092-2.png?v=r6659sol66c-wvc-sizes",
  icon: ShieldCheck,
  link: {
    href: "https://book.mylimobiz.com/v4/bemax",
    newTab: true
  }
}, {
  id: "SVC-03",
  name: "Punctual Logistics",
  description: "Precision scheduling and real-time monitoring to ensure you arrive exactly when expected, every time.",
  tags: ["#PRECISION", "#TIMELY", "#RELIABLE"],
  accentVar: "--chart-2",
  image: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_4027.webp?v=xysh46gcn8l",
  srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_4027.webp?v=emgfv1jwj7-wvc-srcset",
  sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_4027.webp?v=vo30vcrwrw-wvc-sizes",
  icon: Clock,
  link: {
    href: "https://book.mylimobiz.com/v4/bemax",
    newTab: true
  }
}, {
  id: "SVC-04",
  name: "Airport Transfers",
  description: "Seamless transitions from terminal to destination with flight tracking and personalized meet-and-greet.",
  tags: ["#AIRPORT", "#TRANSFERS", "#CONCIERGE"],
  accentVar: "--chart-4",
  image: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/airport-pick-up-and-drop-off-near-me.webp?v=u3g0u71tbu",
  srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/airport-pick-up-and-drop-off-near-me.webp?v=ljrfd2lyyje-wvc-srcset",
  sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/airport-pick-up-and-drop-off-near-me.webp?v=c5y9xjxpjyf-wvc-sizes",
  icon: MapPin,
  link: {
    href: "https://book.mylimobiz.com/v4/bemax",
    newTab: true
  }
}, {
  id: "SVC-05",
  name: "Group Travel",
  description: "Spacious, high-end transport solutions for corporate teams, events, and private group excursions.",
  tags: ["#CORPORATE", "#GROUPS", "#SPACIOUS"],
  accentVar: "--chart-1",
  image: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/VLL-Fleet-Photos-21.jpg.jpeg?v=4hlpn23sq8",
  srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/VLL-Fleet-Photos-21.jpg.jpeg?v=vgwb45ervvs-wvc-srcset",
  sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/VLL-Fleet-Photos-21.jpg.jpeg?v=wmo5i7d913i-wvc-sizes",
  icon: Users
}, {
  id: "SVC-06",
  name: "Event Service",
  description: "Tailored itineraries and personalized amenities designed to exceed the expectations of our most discerning clients.",
  tags: ["#BESPOKE", "#PREMIUM", "#TAILORED"],
  accentVar: "--chart-2",
  image: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3796-2.png?v=ixmdt37cgxo",
  srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3796-2.png?v=azjcx6hvdq6-wvc-srcset",
  sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3796-2.png?v=c51b073bzng-wvc-sizes",
  icon: Sparkles,
  link: {
    href: "https://book.mylimobiz.com/v4/bemax",
    newTab: true
  }
}];
export default function Differentiators() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="530" id="differentiatorsgrid" className="bg-background text-foreground relative overflow-hidden py-20 sm:py-28 lg:py-36" style={{
    backgroundImage: "radial-gradient(ellipse at center, var(--background) 0%, #050505 100%)"
  }}>
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-12">
            <span className="font-mono text-xs sm:text-sm tracking-widest uppercase" style={{
            color: "#C0C0C0"
          }}>
              BEMAX LIMO CHAUFFEURED SERVICE
            </span>
          </div>
          <div className="lg:col-span-10 lg:col-start-2">
            <h2 className="font-serif font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[88px] leading-[1.05] tracking-tight text-foreground">
              Refined travel.
              <br />
              <span className="text-muted-foreground">Designed for the discerning.</span>
            </h2>
          </div>
        </div>

        <div ref={gridRef} className="mt-16 grid grid-cols-1 gap-px bg-border/40 md:grid-cols-2 lg:grid-cols-3">
          {labs.map((lab, i) => {
          const Icon = lab.icon;
          return <article key={lab.id} data-index={i} className={`group relative flex flex-col bg-background border border-border/40 transition-all duration-700 ease-out hover:border-transparent md:h-[480px] ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: gridVisible ? `${i * 80}ms` : "0ms",
            "--lab-accent": `var(${lab.accentVar})`
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = "#C0C0C0";
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = "";
          }}>
                <div className="relative h-48 sm:h-52 overflow-hidden">
                  <div className="absolute inset-0 transition-all duration-700 ease-out group-hover:opacity-100" style={{
                background: `linear-gradient(135deg, #111111 0%, #000000 100%)`,
                opacity: 0.85
              }} />
                  <img src={lab.image} data-wvc-srcset={lab.srcset} data-wvc-sizes={lab.sizes} alt={lab.name} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover mix-blend-luminosity grayscale opacity-60 transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:opacity-90 group-hover:mix-blend-normal" />
                  <div className="absolute top-4 right-4">
                    <Icon className="h-5 w-5 text-foreground/70 transition-colors duration-500 group-hover:text-foreground" strokeWidth={1.5} />
                  </div>
                </div>

                <div className="relative flex flex-1 flex-col p-6 sm:p-7">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-xs tracking-widest text-muted-foreground transition-colors duration-500">
                      [{lab.id}]
                    </span>
                    <span className="font-mono text-xs text-muted-foreground/60">
                      /{String(i + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <h3 className="font-serif font-default mt-4 text-2xl sm:text-3xl leading-tight tracking-tight text-foreground">
                    {lab.name}
                  </h3>

                  <p className="mt-3 text-[15px] leading-relaxed text-muted-foreground">
                    {lab.description}
                  </p>

                  <ul className="mt-5 flex flex-wrap gap-2">
                    {lab.tags.map((tag, ti) => <li key={ti} data-index={ti} className="font-mono text-[11px] tracking-wider text-muted-foreground border border-border/60 px-2 py-1 rounded-sm transition-colors duration-300 group-hover:text-foreground group-hover:border-border">
                        {tag}
                      </li>)}
                  </ul>

                  <Link className="mt-auto overflow-hidden pt-6 underline cursor-pointer" data-ores-widget="quickres" data-ores-alias="bemax" {...lab.link}>
                    <div>
                      <Link to="/SecureChauffeurPage" className="font-mono text-xs tracking-widest uppercase flex items-center gap-2 translate-y-8 opacity-0 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100" style={{
                    color: "#C0C0C0"
                  }}>
                        <span>RESERVE NOW</span>
                        <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
                      </Link>
                    </div>
                  </Link>
                </div>

                <span aria-hidden="true" className="pointer-events-none absolute top-0 left-0 h-3 w-3 border-t border-l opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
              borderColor: "#C0C0C0"
            }} />
                <span aria-hidden="true" className="pointer-events-none absolute bottom-0 right-0 h-3 w-3 border-b border-r opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
              borderColor: "#C0C0C0"
            }} />
              </article>;
        })}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild variant="ghost" className="font-mono text-xs sm:text-sm tracking-widest uppercase text-foreground hover:bg-transparent hover:text-foreground group/btn px-0">
            <Link to="/FleetPage" className="inline-flex items-center gap-3">
              <span className="h-px w-8 bg-border transition-all duration-500 group-hover/btn:w-16" style={{
              backgroundColor: "#C0C0C0"
            }} />
              <span>VIEW OUR FULL FLEET</span>
              <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" strokeWidth={1.5} />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}